namespace Vit.Administration {
    @Serenity.Decorators.registerClass()
    export class TenantGrid extends Vit.EntityGrid<TenantRow, any> {
        protected getColumnsKey() { return 'Administration.Tenant'; }
        protected getDialogType() { return TenantDialog; }
        protected getNewDialogType() { return TenantDialog; }
        protected getIdProperty() { return TenantRow.idProperty; }
        protected getLocalTextPrefix() { return TenantRow.localTextPrefix; }
        protected getService() { return TenantService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var cols = super.getColumns();

            return cols;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


            }
        }
    }
}